<template>
  <div class="suggestions" :class="classid == 1 ? 'cc' : ''">
    <!-- 表格展示区域 -->
    <el-table :data="suggestionList" border>
      <el-table-column type="index" width="50" label="#" align="center"> </el-table-column>
      <el-table-column prop="title" align="center" label="标题" width="100">
        <template slot-scope="scope">
          <span>{{ showcontent(scope.row.title) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="content"
        align="center"
        label="内容"
        show-overflow-tooltip
        width="100"
      >
        <template slot-scope="scope">
          <span>{{ showcontent(scope.row.content) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="name" align="center" label="姓名" width="100">
      </el-table-column>
      <el-table-column prop="phone" align="center" width="120" label="电话号码">
      </el-table-column>
      <!-- <el-table-column
        prop="createTime"
        align="center"
        width="110"
        label="创建时间"
      >
      </el-table-column> -->
      <!-- <el-table-column
        prop="replyTime"
        align="center"
        width="100"
        label="回复时间"
      >
      </el-table-column> -->
      <el-table-column
        prop="replyContent"
        align="center"
        label="回复内容"
        show-overflow-tooltip
        width="100"
      >
        <template slot-scope="scope">
          <span v-html="showContent(scope.row.replyContent)"></span>
          <!-- <span>{{ showcontent(scope.row.replyContent) }}</span> -->

          <!-- {{ showContent(scope.row.replyContent) }} -->
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="small"
            @click="openRichDialog(scope.row.id, scope.row.replyContent)"
          >
            回复
          </el-button>
        </template>
      </el-table-column>
      <el-table-column prop="type" align="center" label="类型">
        <template slot-scope="scope">
          <el-tag size="small" :type="scope.row.type == 0 ? '' : 'success'">
            {{ scope.row.type == 0 ? "咨询" : "建议" }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="isPublic" align="center" label="是否公开">
        <template slot-scope="scope">
          <el-tag size="small" :type="scope.row.isPublic == 0 ? '' : 'success'">
            {{ scope.row.isPublic == 0 ? "公开" : "不公开" }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="status" align="center" label="是否显示" width="100">
        <template slot-scope="scope">
          <el-button
            size="mini"
            plain
            :type="scope.row.status == 0 ? 'danger' : 'success'"
            @click="changeShow(scope.row)"
          >
            {{ scope.row.status == 0 ? "不显示" : "显示" }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column prop="auditStatus" align="center" label="审核状态" width="100">
        <template template slot-scope="scope">
          <el-button
            size="mini"
            plain
            class="padding-style"
            :type="checkStyle(scope.row.auditStatus)"
            disable-transitions
            @click="examineStatus(scope.row.id)"
          >
            {{ checkShow(scope.row.auditStatus) }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- banner分页器 -->
    <el-pagination
      background
      layout="total,prev, pager, next"
      :total="courseTotal"
      @current-change="pageChange"
      :page-size="suggestionList.limit"
      :current-page="suggestionList.page"
    >
    </el-pagination>
    <!-- 审核列表的弹框 -->
    <check-status
      :check-query="checkQuery"
      ref="checkRef"
      @updateComputed="getSuggestionList()"
    />
    <el-dialog
      width="50%"
      title="回复内容"
      :visible.sync="innerVisible"
      append-to-body
      @closed="destroyEdit"
    >
      <div id="demo1"></div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitInfo">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import CheckStatus from "@/views/modules/config/child-components/check-status";
import { checkMixin } from "@/utils/mixin.js";
// 引入 wangEditor
import wangEditor from "wangeditor";
// 引入过滤函数
import { showcontent } from "@/utils/method.js";
export default {
  components: { CheckStatus },
  mixins: [checkMixin],
  data() {
    return {
      classid: 0,
      editor: null,
      courseTotal: 0,
      // 内层对话框的显示与隐藏
      innerVisible: false,
      suggestionList: [], //咨询建议列表
      suggestions: {
        replyContent: "",
        id: null,
      },
      // 获取咨询建议列表参数
      demandQuery: {
        limit: 10,
        page: 1,
      },
      // 审核状态参数
      checkQuery: {
        id: null,
        checkStatus: "1",
      },
      totalCount: 0, // 咨询建议总数
      loading: false, //是否处于加载中
      isVisible: false, //控制弹窗的显示或隐藏
    };
  },

  mounted() {
    this.getSuggestionList();
    console.log(this.$route.query);
    if (this.$route.query.id == 1) {
      this.classid = 1;
    } else {
      this.classid = 0;
    }
  },
  methods: {
    showcontent,
    //获取咨询建议列表
    getSuggestionList() {
      this.loading = true;
      this.$ajaxGet("/consult/listAll/open", this.demandQuery).then(
        ({ data }) => {
          console.log(data);
          if (data.code === 0) {
            this.suggestionList = data.data.list;
            this.courseTotal = data.data.totalCount;
            this.loading = false;
            // this.courseQuery.page = 1
          }
        }
      );
    },
    // 审核状态
    examineStatus(id) {
      this.checkQuery.id = id;
      this.$nextTick(() => {
        this.$refs.checkRef.init("/consult/updateAuditStatus");
      });
    },
    // 分页器改变时触发事件
    pageChange(val) {
      this.demandQuery.page = val;
      this.getSuggestionList();
    },
    // 添加回复内容富文本
    openRichDialog(id, replyContent) {
      console.log(id, replyContent);
      this.suggestions.id = id;
      this.innerVisible = true;
      if (!this.editor) {
        this.$nextTick(() => {
          // 创建富文本编辑器实例
          const editor = new wangEditor("#demo1");
          // 配置 onchange 回调函数，将数据同步到 vue 中
          editor.config.onchange = (newHtml) => {
            this.suggestions.replyContent = newHtml;
          };
          // 创建编辑器
          editor.create();
          if (this.suggestions.replyContent !== "") {
            editor.txt.html(showcontent(showcontent(replyContent)));
          }
          this.editor = editor;
        });
      }
    },
    //富文本编辑器确认按钮的回调
    submitInfo() {
      this.innerVisible = false;
      let suggestions = { ...this.suggestions };
      // console.log('文本编辑器',suggestions)
      const { id, replyContent } = suggestions;
      this.$ajaxPost("/consult/update", { id, replyContent }).then(() => {
        // console.log('1',data)
        this.getSuggestionList();
      });
      if (this.editor) {
        this.editor.destroy();
        this.editor = null;
      }
    },
    // 点击显示/不显示按钮
    changeShow(item) {
      let { id } = item;
      // showStatus = showStatus === "1" ? "0" : "1";
      this.$ajaxGet(`/consult/updateStatus/open?id=${id}`, {}).then(
        ({ data }) => {
          if (data.code === 0) {
            this.getSuggestionList();
          }
        }
      );
    },
    //关闭文本编辑器时销毁编辑器
    destroyEdit() {
      if (this.editor) {
        this.editor.destroy();
        this.editor = null;
      }
    },
  },
  computed: {
    //将回复内容进行两次转义
    showContent() {
      return (item) => {
        return showcontent(showcontent(item));
      };
    },
  },
};
</script>

<style lang="less" scoepd>
.cc {
  background: #fff;
  padding: 20px;
}
p{
  margin: 0 !important;
}
p {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  display: inline-block;
  width: 100%;
}
</style>